import { db } from './db';
import { newUuid } from './uuid';

export async function enqueue(job) {
  const clientUuid = job.clientUuid || newUuid();

  if (job.op === 'update' || job.op === 'delete') {
    const create = await db.outbox
      .where('clientUuid').equals(clientUuid)
      .filter((j) => j.op === 'create' && j.status !== 'error')
      .first();
    if (create) {
      if (job.op === 'delete') {
        await db.outbox.delete(create.seq);
      } else {
        await db.outbox.update(create.seq, { body: { ...create.body, ...job.body } });
      }
      return { clientUuid, coalesced: true };
    }
  }

  await db.outbox.add({
    entity: job.entity,
    op: job.op,
    clientUuid,
    method: job.method,
    url: job.url,
    body: job.body || null,
    status: 'pending',
    attempts: 0,
    error: null,
  });
  return { clientUuid, coalesced: false };
}

export function listPending() {
  return db.outbox.where('status').notEqual('error').sortBy('seq');
}

export function listErrors() {
  return db.outbox.where('status').equals('error').sortBy('seq');
}

export async function pendingCount() {
  return db.outbox.where('status').notEqual('error').count();
}
